<template>
  <HeadTitle
    title="Crear cliente"
    description="Formulario de creación de un cliente con sus parámetros de integración "
  />
  <br />
  <div class="step">
    <span>1</span>
    <h4>Datos básicos</h4>
    <br />
  </div>
  <div class="step-body w-5 sm:w-8">
    <div class="input-text mr-2">
      <label for="code" class="pb-2">Código</label>
      <InputText v-model="code" />
    </div>
    <div class="input-text">
      <label for="name" class="pb-2">Nombre</label>
      <InputText v-model="name" />
    </div>
  </div>
  <Divider />
  <div class="step">
    <span>2</span>
    <h4>Tipo de integración</h4>
    <br />
  </div>
  <div class="step-body">
    <Dropdown
      v-model="selectedIntegration"
      :options="integrations"
      optionLabel="name"
      placeholder="Seleccionar..."
      class="select-integration md:w-14rem"
    />
  </div>
  <template v-if="integrationFields?.length !== 0">
    <Divider />
    <div class="step">
      <span>3</span>
      <h4>Campos de integración</h4>
    </div>
    <div class="step-body">
      <form id="integration-form" v-show="integrationFields">
        <div class="input-text mr-3 mb-3" v-for="field in integrationFields">
          <label :for="field.name" class="mb-2 font-medium">{{
            field.name
          }}</label>
          <InputText v-model="values[field.name]" />
        </div>
      </form>
    </div>
  </template>
  <footer class="flex flex-column mt-auto mr-8 mb-5">
    <Divider />
    <div class="flex flex-row align-self-end">
      <Button
        class="mr-2 text-sm font-light"
        label="Cancelar"
        severity="secondary"
        @click="router.back()"
      />
      <Button
        v-if="integrationFields?.length !== 0"
        class="text-sm font-light mr-4"
        :class="{ 'p-disabled': !readyToSave }"
        label="Guardar"
        severity="primary"
        @click="save"
      />
    </div>
  </footer>
</template>
<script lang="ts" setup>
  import { computed, onMounted, ref, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import * as yup from 'yup'
  import { getIntegratons, createClient } from '../services/clientService'
  import Integration from '../models/Integration'
  import { useField, useForm } from 'vee-validate'
  import { FilterMatchMode } from 'primevue/api'
  import useNotifications from '@/store/notification'
  import HeadTitle from '@/shared/components/HeadTitle.vue'

  const router = useRouter()
  const selectedIntegration = ref()

  const integrationFields = ref<Array<any>>()
  const { values, resetForm } = useForm()
  const integrations = ref<Integration[]>()
  const notificationStore = useNotifications()

  const { value: code, errorMessage: codeError } = useField<string>(
    'code',
    yup.string().required('El código es requerido')
  )
  const { value: name, errorMessage: nameError } = useField<string>(
    'name',
    yup.string().required('el nombre es requerido')
  )
  watch(selectedIntegration, (newSelected: Integration, old) => {
    const { requiredFields } = newSelected
    const requiredFieldArray = Object.entries(requiredFields).map(
      ([fieldName, fieldType]) => ({
        name: fieldName,
        type: fieldType,
      })
    )

    integrationFields.value = requiredFieldArray
  })

  onMounted(() => {
    getIntegratons().then((response) => (integrations.value = response))
  })

  const isFormEmpty = computed(() => {
    let flag = false
    integrationFields.value?.forEach((f) =>
      !values[f.name] || values[f.name] === '' ? (flag = true) : (flag = false)
    )
    return flag
  })

  const readyToSave = computed(
    () =>
      isFormEmpty.value === false &&
      code.value?.trim() != '' &&
      name.value?.trim() != ''
  )

  const save = async () => {
    const { code: Code, name: Name, ...integrationFields } = values
    const response = await createClient({
      code: code.value,
      name: name.value,
      integrationTypeId: selectedIntegration.value.id,
      integrationFields: integrationFields,
    })

    if (response === 'OK') {
      notificationStore.addSuccesNotification({
        detail: `200`,
        severity: 'success',
        summary: `Cliente creado con exito`,
      })

      router.push('/clients')
    }
  }
</script>
<style scoped>
  .step {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 1rem;
  }

  .step span {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    border-color: #3b82f6;
    background-color: #3b82f6;
    color: white;
    margin-right: 15px;
  }

  .step-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 1rem;
    margin-left: 3rem;
  }

  #integration-form {
    display: flex;
    flex-flow: row wrap;
    width: 80%;
  }

  .input-text {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
  }

  :deep(.p-column-title) {
    font-size: 14px;
  }

  :deep(.p-datatable-tbody) {
    font-size: 14px;
  }

  :deep(.p-paginator) {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-wrap: wrap;
    font-size: 14px;
  }

  .detail-form {
    display: flex;
    width: 80%;
    margin-top: 2rem;
  }

  .input-text {
    display: flex;
    flex-flow: column wrap;
    margin-right: 10px;
  }
</style>
